import * as React from 'react'
import { connect } from 'react-redux'
import { Action, compose, Dispatch } from 'redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { Button, Col, Icon, Rate, Row, Spin } from 'antd'
import { injectIntl, IntlShape } from 'react-intl'
import { firebaseConnect } from 'react-redux-firebase'
import { ApplicationState } from '../../store'
import * as DeliveryRatingActions from '../../store/DeliveryRating/actions'
import Container from '../../components/Container'
import styles from './DeliveryRating.module.scss'
import NotFound from '../../components/NotFound/NotFound'
import ThanksForRating from '../../components/ThanksForRating/ThanksForRating'
import { ReactComponent as StarImage } from '../../assets/img/off.svg'
import * as AnalyticsManager from '../../lib/analytics/analytics'
import { AnalyticsEvent, PageTypes } from '../../lib/analytics/events'
import env from '../../lib/env'


interface IDeliveryTrackingProps extends RouteComponentProps<any> {
    loading: boolean
    isValid: boolean
    isSent: boolean
    ratingValidate: (token: string) => Action
    ratingCreate: (token: string, rating: number) => Action
    intl: IntlShape
}

interface IDeliveryTrackingState {
    rating: number;
}

class DeliveryRating extends React.Component<IDeliveryTrackingProps, IDeliveryTrackingState> {

    rateText: string[]

    constructor(props: IDeliveryTrackingProps) {
      super(props)

      const { intl: { formatMessage } } = props
      const translate = (id: string, values: any = {}) => formatMessage({ id }, values)
      this.state = {
        rating: 0,
      }

      this.rateText = [
        translate('rating.unrated'),
        translate('rating.poor'),
        translate('rating.below_average'),
        translate('rating.average'),
        translate('rating.good'),
        translate('rating.excellent'),
      ]
    }

    componentDidMount(): void {
      const { ratingValidate, match } = this.props
      const token = match.params.uuid
      ratingValidate(token)
      AnalyticsManager.setRelayEventProperty('page_type', PageTypes.Rating)
      AnalyticsManager.sendCurrentPageView()
    }

    onCreateRating() {
      const { ratingCreate, match } = this.props
      const { rating } = this.state
      const token = match.params.uuid

      AnalyticsManager.sendEvent(AnalyticsEvent.DeliveryRated, { value: rating })
      ratingCreate(token, rating)
    }

    render() {
      const { intl: { formatMessage }, loading, isValid, isSent } = this.props
      const { rating } = this.state
      const translate = (id: string, values: any = {}) => formatMessage({ id }, values)
      const spinnerIcon = <Icon type="loading" className={styles.spinnerIcon} />

      if (!loading && !isValid) {
        return <NotFound inAnotherPage />
      }

      if (!loading && isSent) {
        return <ThanksForRating />
      }

      return (
        <Container className={styles.container}>
          <Spin spinning={loading} size="large" className={styles.spinner} indicator={spinnerIcon} />
          {isValid && (
            <>
              <Row>
                <Col xs={24}>
                  <div className={styles.title}>
                    {translate('rating.title').split('\n').map((f) => {
                      return (<div>{f}</div>)
                    })}
                  </div>
                  <div className={`${styles.description} ${rating === 0 ? styles.unrated : ''}`}>
                    {this.rateText[rating]}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={24}>
                  <Rate
                    className={styles.rate}
                    character={<StarImage />}
                    onChange={
                                (rating) => { this.setState({ rating }) }
                            } />
                </Col>
              </Row>
              <Row>
                <Col xs={24}>
                  <Button
                    disabled={rating === 0}
                    className={styles.rateButton}
                    onClick={() => this.onCreateRating()}>
                    {translate('rating.rate')}
                  </Button>
                </Col>
              </Row>
            </>
          )}

        </Container>
      )
    }
}

const mapStateToProps = ({ containers }: ApplicationState) => ({
  loading: containers.DeliveryRating.loading,
  isValid: containers.DeliveryRating.isValid,
  isSent: containers.DeliveryRating.isSent,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ratingValidate: (token: string) => dispatch(DeliveryRatingActions.ratingValidate(token)),
  ratingCreate: (token: string, rating: number) => dispatch(DeliveryRatingActions.ratingCreate(token, rating)),
})

export default compose(
  withRouter,
  firebaseConnect((props: {match: {params: {uuid: string}}}) => {
    return [{
      path: `${env()}/delivery/${props.match.params.uuid || 'null'}`,
    }]
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  injectIntl,
)(DeliveryRating)
